(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Current Search',
    noCollectionFound: 'No collection found',
    allProducts: 'See all results',
    matching: 'See all results matching',
    sortBy: 'Sorted by',
    relevance: 'Relevance',
    outOf: 'out of',
    resultsFound: 'product results found',
    oneResultFound: '1 product result found',
    noResultFound: 'No product results found',
    addToCart: 'Add to cart',
    searchForProduct: 'Search',
    selectedFilter: 'Selected filters',
    clearAll: 'Clear all',
    noPageFound: 'No page results found',
    outOfStock: 'Out of stock',
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return '<span class="aa-no-product-results-for">No product results for</span> <span data-wg-notranslate="manual">' + render(text) + '</span>';
    },
    /* in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    }, */

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
